(function () {
  var script = document.currentScript;
  if (!script) return;

  var sectionId = script.getAttribute('data-section-id');
  var shell = document.querySelector('[data-bc-concept-section="' + sectionId + '"]');
  var mount = shell && shell.querySelector('[data-bc-concept-mount]');
  var configNode = document.getElementById('BCConceptConfig-' + sectionId);
  if (!shell || !mount || !configNode) return;

  var config;
  try {
    config = JSON.parse(configNode.textContent || '{}');
  } catch (error) {
    mount.innerHTML = '<p class="bc-concept-error">The concept configuration could not be read.</p>';
    return;
  }

  var operationalUrls = {
    delivery: 'https://www.doordash.com/store/buon-cibo-italian-specialties-san-diego-41489460/',
    catering: 'https://www.buoncibosd.com/catering-3',
    preorderFriday: 'https://www.buoncibosd.com/order/p/fridaydinner',
    preorderSunday: 'https://www.buoncibosd.com/order/p/lasagna-sunday',
  };

  var source = window.BuonCiboConceptSources && window.BuonCiboConceptSources[config.pageKey];
  if (!source) {
    mount.innerHTML = '<p class="bc-concept-error">The selected concept source is unavailable.</p>';
    return;
  }

  function replaceEvery(value, find, replacement) {
    return value.split(find).join(replacement);
  }

  // Intrinsic dimensions measured from the theme image assets; keep in sync when replacing files.
  var assetImageDimensions = {
    "bc-deli-counter-thumb.webp": [300, 225],
    "bc-deli-counter.webp": [2500, 1875],
    "bc-deli-watercolor.webp": [1536, 1024],
    "bc-ev-almond-cookie.webp": [1400, 1400],
    "bc-ev-bombolini.webp": [1400, 1400],
    "bc-ev-bread-pudding.webp": [1400, 1400],
    "bc-ev-caesar.webp": [1122, 1402],
    "bc-ev-cannoli-plate.webp": [1400, 1400],
    "bc-ev-cannoli-torte.webp": [1400, 1400],
    "bc-ev-cannoli.webp": [1320, 1632],
    "bc-ev-cassatini.webp": [1400, 1400],
    "bc-ev-chocolate-cake-slice-v2.webp": [1254, 1254],
    "bc-ev-chocolate-cake-slice.webp": [1254, 1254],
    "bc-ev-cream-puff.webp": [1400, 1400],
    "bc-ev-danish.webp": [1400, 1400],
    "bc-ev-friday-dinner-thumb.webp": [300, 375],
    "bc-ev-friday-dinner.webp": [1024, 1280],
    "bc-ev-italian-cookies.webp": [1400, 1400],
    "bc-ev-lasagna-sunday-square-thumb.webp": [300, 300],
    "bc-ev-lasagna-sunday-square.webp": [1400, 1400],
    "bc-ev-lasagna-sunday.webp": [1122, 1402],
    "bc-ev-lemon-tart.webp": [1400, 1400],
    "bc-ev-limoncello-cake.webp": [1400, 1400],
    "bc-ev-lobster-tail.webp": [1400, 1400],
    "bc-ev-orange-ricotta-bundt.webp": [1400, 1400],
    "bc-ev-paint-sip-easel-thumb.webp": [300, 300],
    "bc-ev-paint-sip-easel.webp": [1400, 1400],
    "bc-ev-paint-sip.webp": [1400, 1866],
    "bc-ev-paint-sunset-turtle.webp": [1400, 1400],
    "bc-ev-pot-sip-thumb.webp": [300, 300],
    "bc-ev-pot-sip.webp": [1400, 1400],
    "bc-ev-s-cookie.webp": [1400, 1400],
    "bc-ev-tiramisu-slice.webp": [1400, 1400],
    "bc-ev-tiramisu.webp": [1400, 1866],
    "bc-ev-torta-della-nonna.webp": [1400, 1400],
    "bc-ev-wine-night-guests.webp": [1320, 1760],
    "bc-ev-wine-pairing.webp": [1122, 1402],
    "bc-ev-wine-spain-2.webp": [1122, 1402],
    "bc-ev-wine-spain-3.webp": [1122, 1402],
    "bc-ev-wine-spain-thumb.webp": [300, 375],
    "bc-ev-wine-spain.webp": [1122, 1402],
    "bc-hero-closed-day.webp": [1400, 1340],
    "bc-hero-closed-dusk.webp": [1400, 1340],
    "bc-hero-happy-wine-counter.webp": [1400, 1340],
    "bc-hero-lunch-sandwich-counter.webp": [1400, 1340],
    "bc-hero-lunch-sandwich-mosaic.webp": [1400, 1340],
    "bc-hero-morning-pastry-case.webp": [1400, 1340],
    "bc-lasagna-sunday.png": [941, 1672],
    "bc-logo-script.png": [433, 218],
    "bc-logo-teal.png": [433, 218],
    "bc-logo-v3.png": [433, 218],
    "bc-logo.webp": [433, 218],
    "bc-meal-breaded-cod.webp": [1400, 1400],
    "bc-meal-cheese-lasagna.webp": [1400, 1400],
    "bc-meal-chicken-marsala.webp": [1400, 1400],
    "bc-meal-chicken-parmigiana.webp": [1400, 1400],
    "bc-meal-chicken-pesto-lasagna.webp": [1400, 1400],
    "bc-meal-eggplant-parmigiana.webp": [1400, 1400],
    "bc-meal-meat-lasagna.webp": [1400, 1400],
    "bc-meal-meatballs.webp": [1400, 1400],
    "bc-meal-mushroom-risotto.webp": [1400, 1400],
    "bc-meal-penne-marinara.webp": [1400, 1400],
    "bc-meal-penne-vodka.webp": [1400, 1400],
    "bc-meal-ravioli-marinara.webp": [1400, 1400],
    "bc-meal-rigatoni-pesto.webp": [1400, 1400],
    "bc-meal-short-rib.webp": [1400, 1400],
    "bc-meal-spaghetti-meatballs.webp": [1400, 1400],
    "bc-meal-stuffed-pepper.webp": [1400, 1400],
    "bc-paint-sip-film-poster.webp": [720, 1280],
    "bc-paint-sip-poster.webp": [900, 1126],
    "bc-palermo-room.webp": [1130, 980],
    "bc-photo-dining-panorama-a.webp": [1800, 1013],
    "bc-photo-dining-panorama-b.webp": [1800, 1013],
    "bc-photo-dining-room-wide.webp": [1350, 1800],
    "bc-photo-dining-tables-sun.webp": [1581, 1800],
    "bc-photo-dining-window-olive.webp": [1350, 1800],
    "bc-photo-exterior-blue-sky.webp": [1350, 1800],
    "bc-photo-exterior-dusk.webp": [1350, 1800],
    "bc-photo-grazing-table-detail.webp": [1800, 1350],
    "bc-photo-grazing-table-wall.webp": [1350, 1800],
    "bc-photo-grazing-table-wide.webp": [1350, 1800],
    "bc-photo-market-floor.webp": [1800, 1350],
    "bc-photo-meatballs-pan.webp": [1350, 1800],
    "bc-photo-pastry-case.webp": [1472, 1800],
    "bc-photo-patio-green-door.webp": [1350, 1800],
    "bc-photo-sandwich-counter.webp": [1350, 1800],
    "bc-photo-sandwich-patio-mosaic.webp": [1695, 1800],
    "bc-photo-wine-beer-counter.webp": [1350, 1800],
    "bc-photo-wine-wall-neon.webp": [1350, 1800],
    "bc-sandwich-interior.webp": [1000, 868],
    "bc-sandwich-mosaic.webp": [1000, 1062],
    "bc-sandwich-patio.webp": [1000, 1060],
    "bc-sandwich-winewall.webp": [1000, 1210],
    "bc-sugo-sunday.webp": [1122, 1402],
    "bc-thumb-almond-cookie.webp": [124, 124],
    "bc-thumb-bombolini.webp": [124, 124],
    "bc-thumb-bread-pudding.webp": [124, 124],
    "bc-thumb-cannoli-torte.webp": [124, 124],
    "bc-thumb-cannoli.webp": [124, 124],
    "bc-thumb-cassatini.webp": [124, 124],
    "bc-thumb-cream-puff.webp": [124, 124],
    "bc-thumb-danish.webp": [124, 124],
    "bc-thumb-italian-cookies.webp": [124, 124],
    "bc-thumb-lemon-tart.webp": [124, 124],
    "bc-thumb-limoncello-cake.webp": [124, 124],
    "bc-thumb-lobster-tail.webp": [124, 124],
    "bc-thumb-orange-ricotta-bundt.webp": [124, 124],
    "bc-thumb-s-cookie.webp": [124, 124],
    "bc-thumb-tiramisu.webp": [124, 124],
    "bc-thumb-torta-della-nonna.webp": [124, 124],
    "bc-tile-cannoli.webp": [360, 360],
    "bc-tile-cassatina.webp": [360, 360],
    "bc-tile-lobster-tail.webp": [360, 360],
    "bc-tile-tiramisu.webp": [360, 360],
    "bc-wine-pour.png": [1820, 2280],
    "bc-wine-spread.png": [3174, 1786],
    "bc-wine-table.png": [1824, 2280],
    "bc-wine-wall.webp": [1000, 1333]
  };

  var nativeImageMetadata = {};

  function imageUrl(value) {
    try {
      var url = new URL(value, window.location.origin);
      if (url.hostname !== window.location.hostname && url.hostname !== 'cdn.shopify.com') return null;
      if (!/\/(?:cdn\/shop\/|s\/files\/)/.test(url.pathname)) return null;
      return url;
    } catch (error) {
      return null;
    }
  }

  function nativeImageKey(url) {
    var key = new URL(url.href);
    key.searchParams.delete('width');
    return key.pathname + '?' + key.searchParams.toString();
  }

  function rememberNativeImage(src, width, height, alt) {
    var url = imageUrl(src);
    if (!url || !width || !height) return;
    nativeImageMetadata[nativeImageKey(url)] = { width: Number(width), height: Number(height), alt: alt || '' };
  }

  var productImages = config.products || {};
  [productImages.primary, productImages.secondary].concat(productImages.heatEat || [], productImages.addons || []).forEach(function (product) {
    if (product) rememberNativeImage(product.featuredImage || product.image, product.imageWidth, product.imageHeight, product.imageAlt);
  });
  (config.menuImages || []).forEach(function (image) {
    rememberNativeImage(image.src, image.width, image.height, image.alt);
  });
  ['call', 'office'].forEach(function (key) {
    var images = config.cateringImages || {};
    rememberNativeImage(images[key], images[key + 'Width'], images[key + 'Height'], images[key + 'Alt']);
  });

  function knownImage(src) {
    if (!src || src.indexOf('{{') !== -1) return null;
    var url = imageUrl(src);
    if (!url) return null;
    var filename = decodeURIComponent(url.pathname.split('/').pop()).replace(/_\d+x(?=\.[^.]+$)/, '');
    var dimensions = /\/assets\//.test(url.pathname) && assetImageDimensions[filename];
    if (dimensions) return { url: url, asset: filename, width: dimensions[0], height: dimensions[1] };
    var metadata = nativeImageMetadata[nativeImageKey(url)];
    return metadata ? { url: url, width: metadata.width, height: metadata.height, alt: metadata.alt } : null;
  }

  function sizedImageUrl(info, width) {
    var url = new URL(info.url.href);
    if (info.asset) {
      url.pathname = url.pathname.slice(0, url.pathname.lastIndexOf('/') + 1) + info.asset;
      url.searchParams.set('width', String(width));
    } else {
      url.searchParams.set('width', String(width));
      if (url.searchParams.has('height')) url.searchParams.set('height', String(Math.round(width * info.height / info.width)));
    }
    return url.href;
  }

  function prepareImage(image, rendered) {
    var info = knownImage(image.getAttribute('src'));
    // The runtime redraws each source <img> by copying its attributes in order. With srcset and
    // sizes ahead of loading="lazy", the copy started downloading the moment the attributes
    // were set, at the 75vw guess: on a wide high-density screen Menu pulled every Heat & Eat
    // photo at 1400px, about 8 MB, for 78px thumbnails. Putting loading first (and src after it)
    // makes the copy wait for layout, by which time the rendered pass has measured it. Applies to
    // every source image, including ones that already said lazy after their src. 2026-10-18.
    if (!rendered) {
      var sourceSrc = image.getAttribute('src');
      var sourceLoading = image.getAttribute('loading') || 'lazy';
      image.removeAttribute('src');
      image.removeAttribute('loading');
      image.setAttribute('loading', sourceLoading);
      if (sourceSrc !== null) image.setAttribute('src', sourceSrc);
    }
    image.decoding = 'async';
    if (info) {
      image.setAttribute('width', String(info.width));
      image.setAttribute('height', String(info.height));
      // Preserve intentional empty alt text on decorative duplicates and adjacent-label thumbnails.
      if (info.alt && image.getAttribute('alt') !== '') image.alt = info.alt;
      if (info.asset === 'bc-palermo-room.webp' && image.alt === 'Guests seated beneath the arched window in the private room') {
        image.alt = 'Guests seated at yellow tables beside the wine wall and arched window at Buon Cibo';
      }
      var largest = Math.min(1600, info.width);
      var widths = [160, 320, 480, 720, 960, 1200, 1600].filter(function (width) { return width < largest; });
      widths.push(largest);
      var srcset = widths.map(function (width) { return sizedImageUrl(info, width) + ' ' + width + 'w'; }).join(', ');
      if (image.getAttribute('srcset') !== srcset) image.setAttribute('srcset', srcset);
      var rect = rendered ? image.getBoundingClientRect() : null;
      var sizes = rect && rect.width > 0 ? Math.ceil(rect.width) + 'px' : (info.width <= 600 ? info.width + 'px' : '(max-width: 749px) 100vw, 75vw');
      if (image.getAttribute('sizes') !== sizes) image.setAttribute('sizes', sizes);
    }
    if (!rendered) return;
    var bounds = image.getBoundingClientRect();
    var aboveFold = bounds.width > 0 && bounds.height > 0 && bounds.top < window.innerHeight && bounds.bottom > 0;
    if (aboveFold) {
      image.loading = 'eager';
      if (!image.closest('header, footer') && bounds.width > 240 && bounds.height > 180) image.setAttribute('fetchpriority', 'high');
    } else if (!image.hasAttribute('loading')) {
      image.loading = 'lazy';
    }
  }

  Object.keys(config.assets || {}).forEach(function (sourcePath) {
    source = replaceEvery(source, sourcePath, config.assets[sourcePath]);
  });

  Object.keys(config.routes || {}).forEach(function (sourcePath) {
    source = replaceEvery(source, sourcePath, config.routes[sourcePath]);
  });

  if (config.pageKey === 'wine-events') {
    source = replaceEvery(source, '$90 all in', '$90 per person');
    source = replaceEvery(source, 'T21:00-07:00', 'T20:00-07:00');
  }

  if (config.pageKey === 'heat-eat') {
    source = replaceEvery(source, 'seven-meal', 'five-meal');
    source = replaceEvery(source, 'seven meals', 'five meals');
    source = replaceEvery(source, 'Everything is made fresh and keeps in the refrigerator for up to five days.', 'Choose your meals and requested pickup date below.');
    source = replaceEvery(source, 'Individual meals run $14 to $18 depending on the dish.', 'Individual meals range from $12.50 to $16.50, as shown below.');
    source = replaceEvery(source, 'Individual meals are $14 to $18 depending on the dish. Prices and availability are confirmed in the store.', 'Individual meal prices are connected to Shopify. The grilled chicken remains priced by the pound; call for today’s price.');
    source = replaceEvery(source, 'Tap the plus beside any meal to keep a list. Nothing is ordered here &mdash; it is something to read us over the phone.', 'Tap the plus beside any meal. Choose five for the $75 bundle, or buy dishes individually.');
    source = replaceEvery(source, 'Call and read us the list', 'Review your selections below');
    source = replaceEvery(source, 'bundlePerMeal: Math.round(bundle / 7)', 'bundlePerMeal: Math.round(bundle / 5)');
    source = replaceEvery(source, 'if (count >= 4 && count < 7)', 'if (count >= 1 && count < 5)');
    source = replaceEvery(source, 'if (count >= 7)', 'if (count >= 5)');
    source = replaceEvery(source, 'A few more and the five-meal assortment at $" + bundle + " costs less than picking them one by one. Ask what is in it this week.', 'Choose exactly five meals for the $" + bundle + " bundle.');
    source = replaceEvery(source, 'That is five or more. The assortment at $" + bundle + " is the cheaper way to do it \u2014 ask what is included this week.', 'Five meals complete the $" + bundle + " bundle.');
  }

  if (config.pageKey === 'wine-events' && config.wineView) {
    var wineVariant = {
      'The Ticket': 'a',
      'The Invitation': 'b',
      'The Program': 'c',
    }[config.wineView];
    if (wineVariant) {
      source = source.replace('state = { v: "a"', 'state = { v: "' + wineVariant + '"');
      source = source.replace(
        'const v = localStorage.getItem("bc-wine-variant-3");',
        'const v = null;'
      );
    }
  }

  // Keep preorder navigation explicit and leave one Cart link in the primary nav.
  // Remove the old Reserve shortcut and the duplicate counted-cart action before
  // the concept runtime builds its header and mobile menu.
  function simplifyHeaderActions(container) {
    Array.from(container.querySelectorAll('header a')).forEach(function (link) {
      if (link.closest('nav')) return;
      var label = (link.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^Reserve$/i.test(label) || /^Cart\s*·/i.test(label)) link.remove();
    });
  }

  var parsed = new DOMParser().parseFromString(source, 'text/html');
  var root = parsed.querySelector('x-dc');
  var logic = parsed.querySelector('script[data-dc-script]');

  if (!root || !logic) {
    mount.innerHTML = '<p class="bc-concept-error">The selected concept is incomplete.</p>';
    return;
  }

  try {
    var propsMeta = JSON.parse(logic.getAttribute('data-props') || '{}');
    Object.keys(config.props || {}).forEach(function (key) {
      if (!propsMeta[key]) return;
      propsMeta[key].default = config.props[key];
    });
    logic.setAttribute('data-props', JSON.stringify(propsMeta));
  } catch (error) {
    // The original runtime still has its own safe defaults.
  }

  simplifyHeaderActions(root);

  // Add dimensions and source candidates before static photographs enter the document.
  Array.from(root.querySelectorAll('img')).forEach(function (image) { prepareImage(image, false); });
  mount.innerHTML = root.outerHTML + logic.outerHTML;
  shell.setAttribute('data-page-key', config.pageKey || '');
  shell.setAttribute('data-review-controls', config.showReviewControls ? 'true' : 'false');

  function connectFooterRoutes() {
    if (mount.querySelector('[data-bc-footer-routes]')) return;

    var footers = mount.querySelectorAll('footer');
    var footer = footers.length ? footers[footers.length - 1] : null;
    if (!footer) return;

    var footerContainer = footer.firstElementChild;
    var footerGrid = footerContainer && Array.from(footerContainer.children).find(function (node) {
      return node.style && node.style.display === 'grid';
    });

    if (footerGrid && Array.isArray(config.footerLinks) && config.footerLinks.length) {
      var nav = document.createElement('nav');
      nav.className = 'bc-footer-route-group';
      nav.setAttribute('aria-label', 'Explore Buon Cibo');
      nav.setAttribute('data-bc-footer-routes', '');

      var heading = document.createElement('div');
      heading.className = 'bc-footer-route-heading';
      heading.textContent = 'Explore';
      nav.appendChild(heading);

      var list = document.createElement('div');
      list.className = 'bc-footer-route-list';
      config.footerLinks.forEach(function (item) {
        if (!item || !item.href || !item.label) return;
        var link = document.createElement('a');
        link.href = item.href;
        link.textContent = item.label;
        list.appendChild(link);
      });
      nav.appendChild(list);

      if (config.showReviewControls) {
        footerGrid.classList.add('bc-connected-footer-grid');
        footerGrid.appendChild(nav);
      } else {
        nav.classList.add('bc-footer-route-group--embedded');
        (footerGrid.lastElementChild || footerGrid).appendChild(nav);
      }
    }

    Array.from(footer.querySelectorAll('a')).forEach(function (link) {
      var label = (link.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^(Instagram|Careers|Gift cards)$/i.test(label)) {
        link.remove();
      }
    });
  }

  function connectSharedFooter() {
    var template = shell.querySelector('[data-bc-footer-variants]');
    if (!template) return;
    var wanted = template.getAttribute('data-bc-footer-default') || 'Compact';
    var current = mount.querySelector('footer[data-bc-footer-variant]');
    if (current && current.getAttribute('data-bc-footer-variant') === wanted) return;
    var variants = Array.from(template.content.querySelectorAll('footer[data-bc-footer-variant]'));
    var pick = variants.find(function (f) { return f.getAttribute('data-bc-footer-variant') === wanted; }) || variants[0];
    if (!pick) return;
    var footers = mount.querySelectorAll('footer');
    var target = current || (footers.length ? footers[footers.length - 1] : null);
    if (!target || !target.parentNode) return;
    var clone = document.importNode(pick, true);
    target.parentNode.replaceChild(clone, target);
  }
  // The page-aware email signup sits directly above the shared footer, or inside a
  // page's [data-bc-newsletter-slot] when it should sit higher (Contact puts it above
  // the form). Guarded so the runtime's re-renders never duplicate it.
  function connectReviewSlots() {
    mount.querySelectorAll('[data-bc-review-slot]').forEach(function (slot) {
      var topic = slot.getAttribute('data-bc-review-topic') || '';
      var mountedStrip = slot.querySelector('[data-bc-review-strip]');
      // The concept renderer can restore an earlier child after changing the topic.
      // Confirm the rendered strip itself matches before accepting the mount marker.
      if (slot.getAttribute('data-bc-review-mounted') === topic &&
        ((mountedStrip && mountedStrip.getAttribute('data-review-topic') === topic) || (!slot.childElementCount && slot.hidden))) return;
      var templates = Array.from(shell.querySelectorAll('template[data-bc-review-template]'));
      var template = templates.find(function (candidate) { return candidate.getAttribute('data-bc-review-template') === topic; });
      var content = template && template.content.querySelector('[data-bc-review-strip]');
      slot.replaceChildren();
      slot.hidden = !content;
      slot.setAttribute('data-bc-review-mounted', topic);
      if (content) slot.appendChild(document.importNode(content, true));
    });
    var wallSlot = mount.querySelector('[data-bc-review-wall-slot]');
    var wallTemplate = shell.querySelector('[data-bc-review-wall-template]');
    if (wallSlot && wallTemplate && !wallSlot.querySelector('[data-bc-review-wall]')) {
      wallSlot.appendChild(document.importNode(wallTemplate.content, true));
      if (window.BuonCiboReviews) window.BuonCiboReviews.mount(wallSlot);
    }
  }

  function connectNewsletter() {
    var template = shell.querySelector('[data-bc-newsletter-template]');
    if (!template || mount.querySelector('[data-bc-newsletter]')) return;
    var block = template.content.querySelector('[data-bc-newsletter]');
    if (!block) return;
    // A page's "Good to know" questions ride in the same template; they go just above the signup.
    function placeQuestions(beforeNode) {
      var questions = template.content.querySelector('.bc-gtk');
      if (!questions || !beforeNode || !beforeNode.parentNode || mount.querySelector('.bc-gtk')) return;
      template.content.querySelectorAll('link[rel="stylesheet"]').forEach(function (link) {
        if (!document.querySelector('link[href="' + link.getAttribute('href') + '"]')) document.head.appendChild(document.importNode(link, true));
      });
      beforeNode.parentNode.insertBefore(document.importNode(questions, true), beforeNode);
      var data = template.content.querySelector('script[type="application/ld+json"]');
      if (data) {
        var script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = data.textContent;
        document.head.appendChild(script);
      }
    }
    var slot = mount.querySelector('[data-bc-newsletter-slot]');
    if (slot) {
      slot.appendChild(document.importNode(block, true));
      placeQuestions(slot);
      return;
    }
    var footer = mount.querySelector('footer[data-bc-footer-variant]');
    if (!footer || !footer.parentNode) return;
    var signup = document.importNode(block, true);
    footer.parentNode.insertBefore(signup, footer);
    placeQuestions(signup);
  }

  connectSharedFooter();
  connectNewsletter();
  connectFooterRoutes();

  function connectHeaderRoutes() {
    simplifyHeaderActions(mount);
    var header = mount.querySelector('header');
    var nav = header && header.querySelector('nav');
    if (!nav || nav.hasAttribute('data-bc-connected-nav')) return;

    nav.setAttribute('data-bc-connected-nav', '');
    nav.setAttribute('aria-label', 'Primary navigation');
    var menuLink = Array.from(nav.querySelectorAll('a')).find(function (link) {
      return /^Menu$/i.test((link.textContent || '').trim());
    });
    var insertAfter = menuLink;

    // Sandwiches and Pinsas are deliberately NOT here any more. They live on the Menu
    // page, which has a section and a jump link for each plus a link out to each dedicated
    // page, and they are both in the footer. Listing them in the top row as well made three
    // of the first four items the same idea - food at the counter.
    [].forEach(function (item) {
      var exists = Array.from(nav.querySelectorAll('a')).some(function (link) {
        return link.getAttribute('href') === item.href;
      });
      if (exists) return;
      var link = document.createElement('a');
      link.href = item.href;
      link.textContent = item.label;
      link.className = 'bc-connected-nav-link';
      if (insertAfter && insertAfter.parentNode === nav) {
        insertAfter.insertAdjacentElement('afterend', link);
        insertAfter = link;
      } else {
        nav.appendChild(link);
      }
    });

    if (!nav.querySelector('a[href="/pages/reviews"]')) {
      var reviewLink = document.createElement('a');
      reviewLink.href = '/pages/reviews';
      reviewLink.textContent = 'Reviews';
      reviewLink.className = 'bc-connected-nav-link';
      var aboutLink = nav.querySelector('a[href="/pages/about"]');
      if (aboutLink) aboutLink.insertAdjacentElement('afterend', reviewLink);
      else nav.appendChild(reviewLink);
    }

    if (!nav.querySelector('a[href="/pages/contact"]')) {
      var contactLink = document.createElement('a');
      contactLink.href = '/pages/contact';
      contactLink.textContent = 'Contact';
      contactLink.className = 'bc-connected-nav-link bc-mobile-nav-link';
      nav.appendChild(contactLink);
    }

    if (!nav.querySelector('a[href="/cart"]')) {
      var navigationCartLink = document.createElement('a');
      navigationCartLink.href = '/cart';
      navigationCartLink.textContent = 'Cart';
      navigationCartLink.className = 'bc-connected-nav-link';
      nav.appendChild(navigationCartLink);
    }

    var headerLinks = Array.from(header.querySelectorAll('a[href]'));
    headerLinks.forEach(function (link) {
      link.removeAttribute('aria-current');
    });
    var currentPath = window.location.pathname.replace(/\/$/, '') || '/';
    var currentLinks = headerLinks.filter(function (link) {
      var linkPath = new URL(link.href, window.location.href).pathname.replace(/\/$/, '') || '/';
      return linkPath === currentPath;
    });
    var currentLink = currentPath === '/'
      ? currentLinks.find(function (link) { return !!link.querySelector('img'); })
      : currentLinks.find(function (link) { return !!link.closest('nav'); });
    if (!currentLink) currentLink = currentLinks[0];
    if (currentLink) currentLink.setAttribute('aria-current', 'page');
  }

  function connectOperationalRoutes() {
    Array.from(mount.querySelectorAll('a')).forEach(function (link) {
      var label = (link.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^Order pickup$/i.test(label) || (/^Pickup$/i.test(label) && link.closest('footer'))) {
        link.href = 'tel:8582656702';
        link.textContent = /^Pickup$/i.test(label) ? 'Call for pickup' : 'Call to order';
      }
    });
  }

  function cateringQuoteTarget() {
    if (mount.querySelector('#quote')) return '#quote';
    if (mount.querySelector('#b-quote')) return '#b-quote';
    if (mount.querySelector('#s-quote')) return '#s-quote';
    return '/pages/contact';
  }

  function connectCateringMenu() {
    if (config.pageKey !== 'catering' || mount.querySelector('[data-bc-catering-menu]')) return;

    var section = document.createElement('section');
    section.className = 'bc-catering-menu';
    section.id = 'premium-catering-menu';
    section.setAttribute('data-bc-catering-menu', '');
    section.setAttribute('aria-labelledby', 'BcPremiumCateringMenuHeading-' + sectionId);
    section.innerHTML = `
      <div class="bc-catering-menu__inner">
        <header class="bc-catering-menu__header">
          <div class="bc-catering-menu__header-copy">
            <span class="bc-catering-menu__kicker">Office lunches & complete meal packages</span>
            <h2 id="BcPremiumCateringMenuHeading-${sectionId}">Boxed lunches and bundled packages.</h2>
            <p>The boxed lunch is the simplest front door. For larger meetings and events, move into pinsas, sandwich trays, lasagna, mixed spreads, vegetarian packages, or the full Italian market table.</p>
          </div>
          <aside class="bc-catering-menu__price-note" aria-label="Catering pickup details">
            <strong>Order by phone for now</strong>
            <p>Currently only accepting these orders over the phone. Online ordering coming soon. Choose your menu, size and pickup details on the product page, then call (858) 265-6702 to confirm availability and place your order.</p>
          </aside>
        </header>

        <div class="bc-catering-menu__featured" role="group" aria-label="Boxed lunch packages">
          <article class="bc-catering-menu__feature">
            <div class="bc-catering-menu__feature-top">
              <div><span class="bc-catering-menu__number">01</span><span class="bc-catering-menu__eyebrow">Flagship office lunch</span><h3>Chef's assorted half-sandwich box</h3></div>
              <div class="bc-catering-menu__price">$19.95<small>per labeled box</small></div>
            </div>
            <p>Half of a large Buon Cibo Italian sandwich with one side, a large chocolate chip cookie, napkin, utensils, and an individual label.</p>
            <ul>
              <li>Chips, Side Antipasto, or Side Caprese</li>
              <li>Chef's assortment or exact sandwich pairs</li>
              <li>Review your selections and kitchen notes before calling</li>
            </ul>
            <div class="bc-catering-menu__meta"><span>Pickup only</span><span>Scripps Ranch</span><span>About 4–5 hours</span></div>
            <a class="bc-catering-menu__button" data-catering-product-link href="/products/chefs-assorted-italian-half-sandwich-boxed-lunch">Choose boxes for your call</a>
          </article>

          <article class="bc-catering-menu__feature">
            <div class="bc-catering-menu__feature-top">
              <div><span class="bc-catering-menu__number">02</span><span class="bc-catering-menu__eyebrow">A more substantial box</span><h3>Italian full-sandwich boxed lunch</h3></div>
              <div class="bc-catering-menu__price">$23.95<small>chips · $26.95 side salad</small></div>
            </div>
            <p>One full Buon Cibo sandwich with chips or side salad, a large chocolate chip cookie, napkin, utensils, and an individual label.</p>
            <ul>
              <li>Nine sandwich choices, including Meatball and Tuto Italiano</li>
              <li>Side salads travel separately with dressing on the side</li>
              <li>Review your selections before calling to order</li>
            </ul>
            <div class="bc-catering-menu__meta"><span>Pickup only</span><span>Scripps Ranch</span><span>About 4–5 hours</span></div>
            <a class="bc-catering-menu__button" data-catering-product-link href="/products/italian-full-sandwich-boxed-lunch">Choose boxes for your call</a>
          </article>
        </div>

        <div class="bc-catering-menu__shared-heading">
          <div><span class="bc-catering-menu__section-label">Shared office and event packages</span><h3>Choose the shape of the table.</h3></div>
          <p>Each package is organized around a real service format: whole pinsas, shared sandwich trays, lasagna by the tray, a mixed office spread, a vegetarian table, or a presentation-driven executive tier.</p>
        </div>

        <div class="bc-catering-menu__packages">
          <details class="bc-catering-menu__package" open>
            <summary><span class="bc-catering-menu__number">03</span><span class="bc-catering-menu__summary-copy"><strong>Roman-style pinsa and salad</strong><span>Whole pinsas · salad · dessert · service items</span></span><span class="bc-catering-menu__summary-price">$219–$529<small>Feeds 10–25 · 4–5 hours</small></span><span class="bc-catering-menu__toggle" aria-hidden="true">+</span></summary>
            <div class="bc-catering-menu__detail">
              <dl class="bc-catering-menu__tiers"><div><dt>Feeds 10</dt><dd>$219</dd></div><div><dt>Feeds 15</dt><dd>$299</dd></div><div><dt>Feeds 20</dt><dd>$419</dd></div><div><dt>Feeds 25</dt><dd>$529</dd></div></dl>
              <div class="bc-catering-menu__detail-copy"><p><strong>Pinsas:</strong> Margherita, Classic Pepperoni, Tuscan Spinach and Mushroom, Spicy Sicilian, or Chicken Florentine. The default assortment uses the first four.</p><p><strong>Salads:</strong></p><ul><li>12 Superfood Kale</li><li>Caprese and Artichoke</li><li>Antipasto</li><li>Beet and Feta</li></ul><p><strong>Dessert:</strong> one cannoli bite or two Italian cookies per person.</p><a class="bc-catering-menu__text-link" data-catering-product-link href="/products/roman-style-pinsa-and-salad-package">Customize for your phone order</a></div>
            </div>
          </details>

          <details class="bc-catering-menu__package">
            <summary><span class="bc-catering-menu__number">04</span><span class="bc-catering-menu__summary-copy"><strong>Italian sandwich and salad trays</strong><span>Sandwich halves · separately packed salad · dessert</span></span><span class="bc-catering-menu__summary-price">$219–$489<small>Feeds 10–25 · 4–5 hours</small></span><span class="bc-catering-menu__toggle" aria-hidden="true">+</span></summary>
            <div class="bc-catering-menu__detail">
              <dl class="bc-catering-menu__tiers"><div><dt>Feeds 10</dt><dd>$219</dd></div><div><dt>Feeds 15</dt><dd>$299</dd></div><div><dt>Feeds 20</dt><dd>$389</dd></div><div><dt>Feeds 25</dt><dd>$489</dd></div></dl>
              <div class="bc-catering-menu__detail-copy"><p>Five to thirteen whole sandwiches are cut into halves and presented on shared trays. Choose the source menu assortment or specify sandwich quantities for your package.</p><p>Salad and dessert selections follow the pinsa package, with every salad packed separately and dressing on the side.</p><a class="bc-catering-menu__text-link" data-catering-product-link href="/products/italian-sandwich-and-separately-packed-salad-package">Customize for your phone order</a></div>
            </div>
          </details>

          <details class="bc-catering-menu__package">
            <summary><span class="bc-catering-menu__number">05</span><span class="bc-catering-menu__summary-copy"><strong>Lasagna tray, salad, and bread</strong><span>Lasagna by the tray · salad · bread · dessert</span></span><span class="bc-catering-menu__summary-price">$189–$519<small>Feeds 6–25 · 12–24 hours</small></span><span class="bc-catering-menu__toggle" aria-hidden="true">+</span></summary>
            <div class="bc-catering-menu__detail">
              <dl class="bc-catering-menu__tiers"><div><dt>Half tray · feeds 6–9</dt><dd>$189</dd></div><div><dt>Full tray · up to 18</dt><dd>$349</dd></div><div><dt>Full + half · up to 25</dt><dd>$519</dd></div></dl>
              <div class="bc-catering-menu__detail-copy"><p><strong>Lasagna choices:</strong></p><ul><li>Meat</li><li>Cheese</li><li>Chicken Pesto</li><li>Pasta al Forno</li></ul><p>Each tier includes a separately packed salad, garlic bread or focaccia, dessert, and service items. Lasagna stays in its tray.</p><a class="bc-catering-menu__text-link" data-catering-product-link href="/products/lasagna-tray-salad-and-bread-package">Customize for your phone order</a></div>
            </div>
          </details>

          <details class="bc-catering-menu__package">
            <summary><span class="bc-catering-menu__number">06</span><span class="bc-catering-menu__summary-copy"><strong>Pinsa and Italian sandwich combo</strong><span>A mixed office table with more variety</span></span><span class="bc-catering-menu__summary-price">$279–$459<small>Feeds 12 or 20 · 12–24 hours</small></span><span class="bc-catering-menu__toggle" aria-hidden="true">+</span></summary>
            <div class="bc-catering-menu__detail">
              <dl class="bc-catering-menu__tiers"><div><dt>Feeds 12</dt><dd>$279</dd></div><div><dt>Feeds 20</dt><dd>$459</dd></div></dl>
              <div class="bc-catering-menu__detail-copy"><p>The 12-person package includes three whole pinsas, six sandwiches cut into twelve halves, salad, dessert, and service items. The 20-person package includes five pinsas and ten sandwiches cut into twenty halves.</p><p>Choose from the same sandwich, pinsa, salad, and dessert pools listed above.</p><a class="bc-catering-menu__text-link" data-catering-product-link href="/products/pinsa-and-italian-sandwich-combo-package">Customize for your phone order</a></div>
            </div>
          </details>

          <details class="bc-catering-menu__package">
            <summary><span class="bc-catering-menu__number">07</span><span class="bc-catering-menu__summary-copy"><strong>Vegetarian Italian office package</strong><span>Sandwich halves · pinsa · hot entrée · salad · dessert</span></span><span class="bc-catering-menu__summary-price">$229–$329<small>Feeds 10 or 15 · 12–24 hours</small></span><span class="bc-catering-menu__toggle" aria-hidden="true">+</span></summary>
            <div class="bc-catering-menu__detail">
              <dl class="bc-catering-menu__tiers"><div><dt>Feeds 10</dt><dd>$229</dd></div><div><dt>Feeds 15</dt><dd>$329</dd></div></dl>
              <div class="bc-catering-menu__detail-copy"><p>Built from Artichoke and Red Pepper Caprese sandwich halves, Tuscan Spinach and Mushroom pinsa, Cheese Lasagna or Eggplant Parmigiana, a separately packed salad, dessert, and service items.</p><p>This package is vegetarian. It is not gluten-free or vegan.</p><a class="bc-catering-menu__text-link" data-catering-product-link href="/products/vegetarian-italian-office-package">Customize for your phone order</a></div>
            </div>
          </details>

          <details class="bc-catering-menu__package">
            <summary><span class="bc-catering-menu__number">08</span><span class="bc-catering-menu__summary-copy"><strong>Executive Italian market spread</strong><span>Imported meats and cheeses · pinsas · salad · dessert</span></span><span class="bc-catering-menu__summary-price">$349–$549<small>Feeds 12 or 20 · 24–48 hours</small></span><span class="bc-catering-menu__toggle" aria-hidden="true">+</span></summary>
            <div class="bc-catering-menu__detail">
              <dl class="bc-catering-menu__tiers"><div><dt>Feeds 12</dt><dd>$349</dd></div><div><dt>Feeds 20</dt><dd>$549</dd></div></dl>
              <div class="bc-catering-menu__detail-copy"><p>The presentation-driven tier for client meetings, celebrations, and executive gatherings: an Italian market-style board with imported meats and cheeses, marinated vegetables, Caprese and Artichoke Salad, whole Roman-style pinsas, dessert, and service items.</p><a class="bc-catering-menu__text-link" data-catering-product-link href="/products/executive-italian-market-spread">Customize for your phone order</a></div>
            </div>
          </details>
        </div>

        <section class="bc-catering-menu__rules" aria-labelledby="BcCateringRulesHeading-${sectionId}">
          <div class="bc-catering-menu__rules-head"><div><span class="bc-catering-menu__section-label">Pickup made simple</span><h3 id="BcCateringRulesHeading-${sectionId}">Everything ready for your table.</h3></div><p>Pickup is at 10380 Spring Canyon Road in Scripps Ranch. Preparation time varies by package; see the product page and call us to confirm same-day pickup.</p></div>
          <ol class="bc-catering-menu__rule-list"><li><b>01</b><strong>Salads stay separate</strong><span>Dressing is always packed on the side.</span></li><li><b>02</b><strong>Pinsas stay whole</strong><span>Roman-style pinsas are not sold as individual slice boxes.</span></li><li><b>03</b><strong>Lasagna stays in the tray</strong><span>It is sold by half or full tray, not as individual catering boxes.</span></li><li><b>04</b><strong>Dessert follows the format</strong><span>Cookies for boxed lunches; cannoli bites or Italian cookies for shared packages.</span></li></ol>
          <div class="bc-catering-menu__closing"><p>For a custom menu or help choosing quantities, call (858) 265-6702 or send a catering inquiry.</p><div class="bc-catering-menu__closing-actions"><a class="bc-catering-menu__button" href="/products/chefs-assorted-italian-half-sandwich-boxed-lunch">Choose boxed lunches</a><a class="bc-catering-menu__button" data-catering-quote-route href="#quote">Ask about a custom menu</a></div></div>
        </section>
      </div>
    `;

    Array.from(section.querySelectorAll('[data-office-lunch-route]')).forEach(function (link) {
      link.href = config.officeLunchOrderUrl || '/products/chefs-assorted-italian-half-sandwich-boxed-lunch';
    });
    Array.from(section.querySelectorAll('[data-catering-quote-route]')).forEach(function (link) {
      link.href = cateringQuoteTarget();
    });

    var legacyAnchor = mount.querySelector('#packages') || mount.querySelector('#b-office');
    var insertionPoint = legacyAnchor && (legacyAnchor.matches('section') ? legacyAnchor : legacyAnchor.closest('section'));
    var footer = mount.querySelector('footer');
    var parent = (insertionPoint && insertionPoint.parentNode) || (footer && footer.parentNode);
    if (!parent) return;
    parent.insertBefore(section, insertionPoint || footer);
  }

  function connectFullCateringMenu() {
    if (config.pageKey !== 'catering') return;
    var template = shell.querySelector('[data-bc-full-catering-menu]');
    var packages = mount.querySelector('#premium-catering-menu');
    if (!template || !packages || !packages.parentNode) return;
    if (!packages.hidden) packages.hidden = true;
    if (!mount.querySelector('[data-bc-full-catering-menu-mounted]')) {
      packages.parentNode.insertBefore(document.importNode(template.content, true), packages);
    }
    var menu = mount.querySelector('[data-bc-full-catering-menu-mounted]');
    if (!menu) return;
    var heroHeading = mount.querySelector('x-dc h1');
    var heroLead = heroHeading && heroHeading.parentNode.querySelector('p');
    var heroCopy = 'Get a catering estimate with a headcount and the dishes you have in mind. Sandwiches, sides and other details can wait until we talk.';
    if (heroLead && heroLead.textContent !== heroCopy) heroLead.textContent = heroCopy;
    var workflowCopy = {
      'Send the form — takes about forty seconds.': 'Share a guest estimate and rough timeframe.',
      'We call you back the same day with a real menu and a real number.': 'Choose your menu, or let us help you plan.',
      'Trays arrive hot, labeled, and ready to set out.': 'Tom calls to confirm the menu, portions and pickup.'
    };
    Array.from(mount.querySelectorAll('span')).forEach(function (node) {
      if (node.children.length) return;
      var next = workflowCopy[(node.textContent || '').trim()];
      if (next) node.textContent = next;
    });

    var replacedBefore = menu.previousElementSibling;
    while (replacedBefore) {
      if (replacedBefore.tagName === 'SECTION' && !replacedBefore.hidden) {
        replacedBefore.hidden = true;
        replacedBefore.setAttribute('data-bc-replaced-catering-content', '');
      }
      replacedBefore = replacedBefore.previousElementSibling;
    }
    Array.from(menu.querySelectorAll('[data-bc-full-catering-quote]')).forEach(function (link) {
      var target = cateringQuoteTarget();
      if (link.getAttribute('href') !== target) link.setAttribute('href', target);
    });
    var heading = mount.querySelector('x-dc h1');
    var actionTemplate = menu.querySelector('[data-bc-full-catering-hero-action]');
    if (heading && heading.parentNode && actionTemplate && !mount.querySelector('[data-bc-full-catering-hero-mounted]')) {
      var action = document.importNode(actionTemplate.content, true);
      var link = action.querySelector('a');
      link.setAttribute('data-bc-full-catering-hero-mounted', '');
      var lead = heading.parentNode.querySelector('p');
      if (lead) lead.insertAdjacentElement('afterend', link);
      else heading.insertAdjacentElement('afterend', link);
    }
    Array.from(mount.querySelectorAll('header nav a')).forEach(function (link) {
      if (/^Catering$/i.test((link.textContent || '').trim()) && link.getAttribute('href') !== '#full-catering-menu') {
        link.setAttribute('href', '#full-catering-menu');
      }
    });
  }

  function alignCateringClaims() {
    if (config.pageKey !== 'catering') return;

    function replaceExact(pattern, replacement) {
      Array.from(mount.querySelectorAll('span, div, p, h2, h3')).forEach(function (node) {
        if (node.children.length) return;
        var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
        if (pattern.test(text)) node.textContent = replacement;
      });
    }

    function hideSectionByHeading(pattern) {
      var heading = Array.from(mount.querySelectorAll('h2, h3')).find(function (node) {
        return pattern.test((node.textContent || '').replace(/\s+/g, ' ').trim());
      });
      var section = heading && heading.closest('section');
      if (section && !section.hasAttribute('data-bc-catering-menu')) {
        section.hidden = true;
        section.setAttribute('data-bc-replaced-catering-content', '');
      }
    }

    replaceExact(/^Build your estimate$/i, 'Tell us about the gathering');
    replaceExact(/^Ballpark updates as you choose\. Nothing is charged and nothing is locked in\.$/i, 'Share the occasion, headcount, and date. We will confirm the current package and final price with you.');
    replaceExact(/^48 hours.? notice for most orders$/i, 'Lead time varies by package · about 4–48 hours');
    replaceExact(/^Delivery, setup, and pickup available$/i, 'Pickup confirmed · delivery requests require approval');
    replaceExact(/^No deposit under 25 guests$/i, 'Final policies are confirmed with your quote');
    replaceExact(/^48 hrs$/i, '4–48 hrs');
    replaceExact(/^Standard notice; same-day when we can swing it$/i, 'Lead time varies by the selected package');
    replaceExact(/^\$16$/i, '8 packages');
    replaceExact(/^Per person for a charcuterie board, in store$/i, 'From labeled boxes to executive spreads');
    replaceExact(/^1949$/i, '10–25');
    replaceExact(/^The year the meatball recipe left Sicily$/i, 'Most shared packages scale by group size');

    Array.from(mount.querySelectorAll('div, span')).forEach(function (node) {
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/^(Office lunch|Party|Charcuterie|Tray) estimate$/i.test(text)) return;
      var estimateCard = node.closest('div[style*="#accabc"]');
      if (estimateCard) estimateCard.hidden = true;
    });

    hideSectionByHeading(/^Four ways people order from us\.?$/i);
    hideSectionByHeading(/^The things people forget to ask for\.?$/i);
    hideSectionByHeading(/^The questions we get every week\.?$/i);
    // Duplicated the closing request and made an unverifiable volume claim.
    hideSectionByHeading(/^Still deciding\? Call and describe the party\.?$/i);

  }

  function buildCateringInquiry() {
    if (config.pageKey !== 'catering') return;
    var quote = mount.querySelector('#quote');
    if (!quote) return;
    // x-dc is the source template, not the mounted page. The runtime compiles it
    // into React and owns any inputs captured there. Wait for its #dc-root commit
    // so these native controls are never compiled into controlled React inputs.
    if (quote.closest('x-dc')) return;
    var existingForm = quote.querySelector('[data-bc-catering-inquiry]');
    // A property identifies the actual native form we bound. If a runtime rebuild
    // copied its markup, replace the copy with fresh native controls before binding.
    if (existingForm && existingForm.__bcCateringInquiryBound) return;
    var previousApi = window.BuonCiboCateringInquiry;
    var previousState = previousApi && previousApi.snapshot ? previousApi.snapshot() : null;
    var stateFields = ['guest_count', 'occasion', 'name', 'phone', 'email', 'event_date', 'notes'];

    quote.innerHTML =
      '<form class="bc-catering-inquiry" data-bc-catering-inquiry novalidate aria-labelledby="bc-catering-request-heading">' +
        '<div class="bc-catering-inquiry__head"><h2 id="bc-catering-request-heading">Request a callback</h2>' +
          '<p>Share a few details. We’ll call to help plan your catering.</p></div>' +
        '<div class="bc-catering-inquiry__grid">' +
          '<label><span>Guest count estimate</span><input type="text" required name="guest_count" data-bc-catering-guests maxlength="60" placeholder="e.g. 25 or 25–35 people" aria-describedby="bc-catering-guests-hint" autocomplete="off">' +
            '<small id="bc-catering-guests-hint" class="bc-catering-inquiry__hint">A rough number or range is fine.</small></label>' +
          '<label><span>Occasion</span><select required name="occasion" data-bc-catering-occasion>' +
            '<option value="">Select occasion</option>' +
            '<option>Office lunch or meeting</option><option>Holiday gathering</option><option>Birthday</option>' +
            '<option>Family gathering</option><option>Wedding or shower</option><option>Party or event</option><option>Other / still planning</option>' +
          '</select></label>' +
          '<fieldset class="bc-catering-inquiry__timing bc-catering-inquiry__wide">' +
            '<legend>When are you thinking?</legend>' +
            '<div class="bc-timing-choices" data-bc-timing-choices role="group" aria-label="Event timing">' +
              '<button type="button" class="bc-timing-option bc-timing-exact" data-bc-timing-exact aria-pressed="false"><span>Choose an exact date</span><span class="bc-timing-check" aria-hidden="true">✓</span></button>' +
            '</div>' +
            '<div class="bc-timing-entry" data-bc-catering-date-field hidden>' +
              '<label><span>Event date</span><input type="date" name="event_date" data-bc-catering-date disabled></label>' +
            '</div>' +
            '<p class="bc-timing-status" data-bc-timing-status role="status" aria-live="polite">An estimate is fine. You can leave this open.</p>' +
          '</fieldset>' +
          '<label><span>Your name</span><input type="text" name="name" required autocomplete="name" placeholder="Your full name" maxlength="120"></label>' +
          '<label><span>Phone</span><input type="tel" name="phone" required autocomplete="tel" placeholder="Best number to call" maxlength="40"></label>' +
          '<label class="bc-catering-inquiry__wide"><span>Email</span><input type="email" name="email" required autocomplete="email" placeholder="you@example.com" maxlength="254"></label>' +
        '</div>' +
        '<details class="bc-catering-inquiry__menu-summary" data-bc-catering-selection-panel hidden>' +
          '<summary data-bc-catering-selection-label>Your menu selections</summary>' +
          '<p data-bc-catering-menu-summary></p>' +
          '<button type="button" class="bc-catering-inquiry__review-menu" data-bc-planner-review>Review / edit selections</button>' +
        '</details>' +
        '<details class="bc-catering-inquiry__details"><summary>Additional details <span>(optional)</span></summary>' +
          '<label><span class="bc-catering-inquiry__sr-only">Additional details</span><textarea name="notes" maxlength="3000" placeholder="Dietary needs, dishes you have in mind, or a good time to call."></textarea></label></details>' +
        '<button class="bc-catering-inquiry__submit" type="submit" data-bc-catering-submit>Request a callback</button>' +
        '<p class="bc-catering-inquiry__trust">Tom will confirm availability, portions and pricing with you. Prefer to call? <a href="tel:8582656702">(858) 265-6702</a>.</p>' +
      '</form>';

    var form = quote.querySelector('[data-bc-catering-inquiry]');
    form.__bcCateringInquiryBound = true;
    form.noValidate = true;
    ['guest_count', 'occasion', 'name', 'phone', 'email'].forEach(function (name) {
      form.querySelector('[name="' + name + '"]').required = true;
    });
    var exactDate = form.querySelector('[data-bc-catering-date]');
    var datePanel = form.querySelector('[data-bc-catering-date-field]');
    var exactButton = form.querySelector('[data-bc-timing-exact]');
    var status = form.querySelector('[data-bc-timing-status]');
    var timing = { kind: 'none', month: '' };
    if (previousState) {
      stateFields.forEach(function (name) {
        if (Object.prototype.hasOwnProperty.call(previousState.fields, name)) {
          form.querySelector('[name="' + name + '"]').value = previousState.fields[name];
        }
      });
      if (previousState.timing) timing = { kind: previousState.timing.kind, month: previousState.timing.month || '' };
      form.querySelector('.bc-catering-inquiry__details').open = previousState.detailsOpen;
    }
    var now = new Date();
    var monthChoices = [];
    for (var monthIndex = 1; monthIndex <= 2; monthIndex += 1) {
      var month = new Date(now.getFullYear(), now.getMonth() + monthIndex, 1);
      var choice = {
        id: month.getFullYear() + '-' + String(month.getMonth() + 1).padStart(2, '0'),
        month: month.toLocaleDateString('en-US', { month: 'long' }),
        year: month.getFullYear()
      };
      monthChoices.push(choice);
      var monthButton = document.createElement('button');
      monthButton.type = 'button';
      monthButton.className = 'bc-timing-option bc-timing-month';
      monthButton.setAttribute('data-bc-timing-month', choice.id);
      monthButton.setAttribute('aria-label', choice.month + ' ' + choice.year);
      monthButton.setAttribute('aria-pressed', 'false');
      var monthName = document.createElement('span');
      monthName.textContent = choice.month;
      var year = document.createElement('small');
      year.textContent = choice.year;
      var check = document.createElement('span');
      check.className = 'bc-timing-check';
      check.setAttribute('aria-hidden', 'true');
      check.textContent = '✓';
      monthButton.append(monthName, year, check);
      form.querySelector('[data-bc-timing-choices]').appendChild(monthButton);
    }
    if (timing.kind !== 'exact' && !monthChoices.some(function (month) { return timing.kind === 'month' && timing.month === month.id; })) {
      timing = { kind: 'none', month: '' };
    }

    function timeframeText() {
      var selected = monthChoices.find(function (month) { return timing.kind === 'month' && timing.month === month.id; });
      return selected ? selected.month + ' ' + selected.year : 'Not sure yet';
    }

    function syncTiming() {
      var exact = timing.kind === 'exact';
      datePanel.hidden = !exact;
      exactDate.disabled = !exact;
      exactDate.required = exact;
      exactButton.setAttribute('aria-pressed', String(exact));
      form.querySelectorAll('[data-bc-timing-month]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(timing.kind === 'month' && timing.month === button.getAttribute('data-bc-timing-month')));
      });
      status.textContent = exact ? 'We’ll confirm availability for this date.' : timing.kind === 'none' ? 'An estimate is fine. You can leave this open.' : timeframeText();
    }

    form.querySelectorAll('[data-bc-timing-month]').forEach(function (button) {
      button.addEventListener('click', function () {
        timing = { kind: 'month', month: button.getAttribute('data-bc-timing-month') };
        syncTiming();
      });
    });
    exactButton.addEventListener('click', function () {
      timing = { kind: 'exact', month: '' };
      syncTiming();
      exactDate.focus();
    });
    form.addEventListener('reset', function () {
      window.setTimeout(function () { timing = { kind: 'none', month: '' }; syncTiming(); }, 0);
    });
    // The delegated click handler owns validation and Shopify contact delivery.
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      form.querySelector('[data-bc-catering-submit]').click();
    });

    // Rebinding must release the prior detached form's global subscription.
    if (window.BuonCiboCateringInquiry && window.BuonCiboCateringInquiry.destroy) {
      window.BuonCiboCateringInquiry.destroy();
    }
    function onPlanChanged(event) {
      window.BuonCiboCateringInquiry.setMenuSummary(event.detail && event.detail.summaryText);
    }
    // Selected items come from the planner and are always rendered as plain text.
    window.BuonCiboCateringInquiry = {
      setMenuSummary: function (summary) {
        var text = typeof summary === 'string' ? summary.trim() : '';
        form.querySelector('[data-bc-catering-menu-summary]').textContent = text;
        form.querySelector('[data-bc-catering-selection-panel]').hidden = !text;
        form.querySelector('[data-bc-catering-selection-panel]').classList.toggle('has-selections', !!text);
        var planner = window.BuonCiboCateringPlanner;
        var count = planner && typeof planner.items === 'function' ? planner.items().length : 0;
        form.querySelector('[data-bc-catering-selection-label]').textContent = 'Your menu selections' + (count ? ' (' + count + ')' : '');
        if (!text) form.querySelector('[data-bc-catering-selection-panel]').open = false;
      },
      readTiming: function () {
        var exact = timing.kind === 'exact';
        return { mode: exact ? 'exact' : 'estimate', date: exact ? exactDate.value : '', timeframe: exact ? '' : timeframeText() };
      },
      destroy: function () {
        window.removeEventListener('bc:catering-plan-changed', onPlanChanged);
      },
      snapshot: function () {
        var fields = {};
        stateFields.forEach(function (name) { fields[name] = form.querySelector('[name="' + name + '"]').value; });
        return {
          fields: fields,
          timing: { kind: timing.kind, month: timing.month },
          detailsOpen: form.querySelector('.bc-catering-inquiry__details').open,
          menuOpen: form.querySelector('[data-bc-catering-selection-panel]').open
        };
      }
    };
    window.addEventListener('bc:catering-plan-changed', onPlanChanged);
    window.BuonCiboCateringInquiry.setMenuSummary(window.BuonCiboCateringPlanner ? window.BuonCiboCateringPlanner.summaryText() : '');
    if (previousState && !form.querySelector('[data-bc-catering-selection-panel]').hidden) {
      form.querySelector('[data-bc-catering-selection-panel]').open = previousState.menuOpen;
    }
    syncTiming();
    mount.dispatchEvent(new CustomEvent('bc:catering-inquiry-ready', { bubbles: true }));
  }

  function connectCateringOrdering() {
    if (config.pageKey !== 'catering' || mount.querySelector('[data-bc-catering-order-bridge]')) return;

    var footers = mount.querySelectorAll('footer');
    var footer = footers.length ? footers[footers.length - 1] : null;
    if (!footer || !footer.parentNode) return;

    var images = config.cateringImages || {};
    var callImage = mount.querySelector('[data-bc-catering-call-image]');
    if (callImage && images.call) {
      callImage.setAttribute('src', images.call);
      if (images.callAlt) callImage.alt = images.callAlt;
    }

    var section = document.createElement('section');
    section.className = 'bc-catering-order-bridge';
    section.setAttribute('data-bc-catering-order-bridge', '');
    section.style.cssText = 'background:#F1F7F5;padding:0;';

    var inner = document.createElement('div');
    inner.className = 'bc-catering-order-bridge__inner';
    inner.style.cssText = 'max-width:1320px;margin:0 auto;padding:0 40px;display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,380px),1fr));gap:0 56px;align-items:center;';

    var media = document.createElement('div');
    media.style.cssText = 'position:relative;min-height:380px;align-self:stretch;';
    var img = document.createElement('img');
    img.src = images.office || '';
    img.alt = images.officeAlt || 'Italian sandwich halves on a wooden board on a mosaic patio table';
    img.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:0 0 8px 8px;';
    if (img.src) media.appendChild(img);

    var copy = document.createElement('div');
    copy.className = 'bc-catering-order-bridge__copy';
    copy.style.cssText = 'padding:72px 0;';
    copy.innerHTML = '<div style="font-size:11.5px;letter-spacing:0.2em;text-transform:uppercase;font-weight:600;color:#17595f;margin-bottom:18px;">Order by phone</div>'
      + '<h2 style="font-family:Outfit,sans-serif;font-size:clamp(30px,3.4vw,46px);font-weight:600;line-height:1.04;letter-spacing:-0.03em;color:#17595f;margin:0 0 18px;text-wrap:balance;">Office lunches, made for your team.</h2>'
      + '<p style="font-size:17px;line-height:1.6;color:rgba(23,89,95,0.9);margin:0 0 30px;max-width:46ch;">Currently only accepting these orders over the phone. Online ordering coming soon. Choose half- or full-sandwich boxed lunches, select your sides and quantities, then call (858) 265-6702 to confirm pickup. Order at least six boxes and allow 4 to 5 hours, subject to kitchen availability.</p>';

    var actions = document.createElement('div');
    actions.className = 'bc-catering-order-bridge__actions';
    actions.style.cssText = 'display:flex;align-items:center;gap:14px;flex-wrap:wrap;';
    var orderLink = document.createElement('a');
    orderLink.href = config.officeLunchOrderUrl || '/products/chefs-assorted-italian-half-sandwich-boxed-lunch';
    orderLink.textContent = 'Half-sandwich boxes';
    orderLink.style.cssText = 'background:#17595f;color:#FFFFFF;font-size:16px;font-weight:600;padding:17px 32px;border-radius:999px;';
    var customLink = document.createElement('a');
    customLink.href = mount.querySelector('#quote') ? '#quote' : (mount.querySelector('#b-quote') ? '#b-quote' : '/pages/contact');
    customLink.textContent = 'Request custom catering';
    customLink.className = 'bc-catering-order-bridge__secondary';
    customLink.style.cssText = 'border:1.5px solid rgba(23,89,95,0.55);color:#17595f;font-size:16px;font-weight:600;padding:15.5px 30px;border-radius:999px;';
    var fullBoxLink = document.createElement('a');
    fullBoxLink.href = '/products/italian-full-sandwich-boxed-lunch';
    fullBoxLink.textContent = 'Full-sandwich boxes';
    fullBoxLink.className = customLink.className;
    fullBoxLink.style.cssText = customLink.style.cssText;
    actions.appendChild(orderLink);
    actions.appendChild(fullBoxLink);
    actions.appendChild(customLink);
    copy.appendChild(actions);
    inner.appendChild(media);
    inner.appendChild(copy);
    section.appendChild(inner);

    var callSection = mount.querySelector('[data-bc-catering-call]');
    if (callSection && callSection.parentNode) callSection.parentNode.insertBefore(section, callSection.nextSibling);
    else footer.parentNode.insertBefore(section, footer);
  }

  function announceOnlineOrderingPause() {
    var page = config.pageKey;
    if (['menu', 'sandwiches', 'pinsas'].indexOf(page) === -1) return;
    if (mount.querySelector('[data-bc-ordering-pause]')) return;
    var header = mount.querySelector('x-dc #top > header') || mount.querySelector('x-dc header');
    if (!header) return;
    var notice = document.createElement('aside');
    notice.setAttribute('data-bc-ordering-pause', '');
    notice.setAttribute('aria-label', 'Online ordering update');
    notice.style.cssText = 'background:#f1f7f5;color:#17595f;padding:18px 24px;text-align:center;font:500 16px/1.5 Outfit,Arial,sans-serif;';
    notice.innerHTML = page === 'catering'
      ? '<strong>Plan now. Confirm with Tom.</strong> Build a catering request or <a href="#quote">ask us to call</a>. Availability, quantities and pricing are confirmed together.'
      : '<strong>Online ordering will be available soon</strong> for sandwiches, individual pinsas, pastries and desserts. The menu is here to browse; call <a href="tel:8582656702">(858) 265-6702</a> for current availability. <a href="#list">Join the email list</a> or <a href="/?first-dibs=1">join email and optional text updates</a> for the launch announcement. Pre-order meals and event tickets are still available online.';
    header.insertAdjacentElement('afterend', notice);
  }

  function repairFragmentRoutes() {
    Array.from(mount.querySelectorAll('a[href]')).forEach(function (link) {
      var href = link.getAttribute('href');
      if (href === '#quote' && !mount.querySelector('#quote')) {
        if (mount.querySelector('#b-quote')) link.setAttribute('href', '#b-quote');
        else if (mount.querySelector('#s-quote')) link.setAttribute('href', '#s-quote');
        else link.setAttribute('href', '/pages/catering');
      }
      if (href === '#packages' && mount.querySelector('#premium-catering-menu')) {
        link.setAttribute('href', '#catering-packages');
      } else if (href === '#packages' && !mount.querySelector('#packages')) {
        link.setAttribute('href', mount.querySelector('#b-office') ? '#b-office' : '/pages/catering');
      }
      if (href === '#' && config.pageKey === 'local-seo') {
        link.setAttribute('href', '/pages/catering');
      }
      if (href === '#top' && link.closest('header') && config.currentPath) {
        link.setAttribute('href', config.currentPath);
      }
    });
  }

  function improveFieldAccessibility() {
    Array.from(mount.querySelectorAll('input, textarea, select')).forEach(function (field) {
      if (field.getAttribute('aria-label') || field.getAttribute('aria-labelledby')) return;
      if (field.labels && field.labels.length) return;

      var type = (field.getAttribute('type') || '').toLowerCase();
      var placeholder = (field.getAttribute('placeholder') || '').trim();
      var fallback = placeholder || field.getAttribute('name') || '';
      if (!fallback && type === 'date') fallback = 'Event date';
      if (!fallback && type === 'range' && config.pageKey === 'private-room') {
        var ranges = Array.from(mount.querySelectorAll('input[type="range"]'));
        fallback = ranges.indexOf(field) === 0 ? 'Number of guests' : 'Reservation length';
      }
      if (!fallback && type === 'range') fallback = 'Selection';
      if (!fallback && type === 'number') fallback = 'Guest count';
      if (!fallback && type === 'email') fallback = 'Email address';
      if (!fallback && type === 'tel') fallback = 'Phone number';
      field.setAttribute('aria-label', fallback || 'Form field');

      if (type === 'email') {
        field.required = true;
        field.setAttribute('autocomplete', 'email');
      }
      if (/name/i.test(placeholder)) field.setAttribute('autocomplete', 'name');
      if (/phone/i.test(placeholder) || type === 'tel') field.setAttribute('autocomplete', 'tel');
    });
  }

  function optimizeImages() {
    Array.from(mount.querySelectorAll('img')).forEach(function (image) { prepareImage(image, true); });
  }

  var imageResizeFrame;
  window.addEventListener('resize', function () {
    window.cancelAnimationFrame(imageResizeFrame);
    imageResizeFrame = window.requestAnimationFrame(optimizeImages);
  }, { passive: true });

  function improveConceptLandmarks() {
    var header = mount.querySelector('header');
    var footer = mount.querySelector('footer');
    var existingMain = mount.querySelector('[data-bc-concept-main]');
    if (existingMain) {
      existingMain.id = 'MainContent';
      existingMain.tabIndex = -1;
      return;
    }

    if (!header || !footer || header.parentElement !== footer.parentElement) {
      var firstHeading = Array.from(mount.querySelectorAll('h1, h2')).find(function (heading) {
        return !heading.closest('[hidden]') && window.getComputedStyle(heading).display !== 'none';
      });
      var fallbackMain = firstHeading && (firstHeading.closest('section') || firstHeading.parentElement);
      if (!fallbackMain) return;
      fallbackMain.id = 'MainContent';
      fallbackMain.tabIndex = -1;
      fallbackMain.setAttribute('role', 'main');
      fallbackMain.setAttribute('data-bc-concept-main', '');
      return;
    }

    var host = header.parentElement;
    var main = document.createElement('main');
    main.id = 'MainContent';
    main.tabIndex = -1;
    main.setAttribute('data-bc-concept-main', '');

    var node = header.nextSibling;
    host.insertBefore(main, node);
    while (node && node !== footer) {
      var next = node.nextSibling;
      main.appendChild(node);
      node = next;
    }
  }

  function improveHeadingStructure() {
    var visibleHeadings = Array.from(mount.querySelectorAll('h1')).filter(function (heading) {
      return !heading.closest('[hidden]') && window.getComputedStyle(heading).display !== 'none';
    });
    if (visibleHeadings.length === 0) {
      var firstLevelTwo = Array.from(mount.querySelectorAll('h2')).find(function (heading) {
        return !heading.closest('[hidden]') && window.getComputedStyle(heading).display !== 'none';
      });
      if (firstLevelTwo) {
        var promoted = document.createElement('h1');
        Array.from(firstLevelTwo.attributes).forEach(function (attribute) {
          promoted.setAttribute(attribute.name, attribute.value);
        });
        promoted.innerHTML = firstLevelTwo.innerHTML;
        firstLevelTwo.replaceWith(promoted);
        visibleHeadings = [promoted];
      }
    }
    visibleHeadings.slice(1).forEach(function (heading) {
      var replacement = document.createElement('h2');
      Array.from(heading.attributes).forEach(function (attribute) {
        replacement.setAttribute(attribute.name, attribute.value);
      });
      replacement.innerHTML = heading.innerHTML;
      heading.replaceWith(replacement);
    });
  }

  function improveChoiceButtonSemantics() {
    function setGroup(buttons, label, selectedColor) {
      if (buttons.length < 2) return;
      var parent = buttons[0].parentElement;
      if (!parent || !buttons.every(function (button) { return button.parentElement === parent; })) return;
      parent.setAttribute('role', 'group');
      parent.setAttribute('aria-label', label);
      buttons.forEach(function (button) {
        var selected = window.getComputedStyle(button).backgroundColor === selectedColor;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    var buttons = Array.from(mount.querySelectorAll('button'));
    if (config.pageKey === 'home') {
      var heroLabels = ['Live', 'Morning', 'Lunch', 'Happy hour', 'Dinner'];
      setGroup(buttons.filter(function (button) { return heroLabels.indexOf((button.textContent || '').trim()) !== -1; }).slice(0, 5), 'Preview home hero by time of day', 'rgb(23, 89, 95)');
      var alertLabels = ['Live', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      var alertButtons = buttons.filter(function (button) { return alertLabels.indexOf((button.textContent || '').trim()) !== -1; }).slice(-8);
      setGroup(alertButtons, 'Preview announcement by day', 'rgb(23, 89, 95)');
      var calendarButtons = Array.from(mount.querySelectorAll('button[data-dc-tpl="138"]'));
      setGroup(calendarButtons, 'Choose a weekly event date', 'rgb(143, 194, 186)');
    }
    if (config.pageKey === 'menu') {
      setGroup(buttons.filter(function (button) {
        return ['List', 'Photos'].indexOf((button.textContent || '').trim()) !== -1;
      }), 'Choose menu layout', 'rgb(23, 89, 95)');
    }
  }

  function hideReviewChrome() {
    var keepHomeHeroControls = config.pageKey === 'home' && config.props && config.props.showPreviewPanel;
    if (config.showReviewControls || keepHomeHeroControls) return;

    Array.from(mount.querySelectorAll('div')).forEach(function (node) {
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      var hasButtons = !!node.querySelector('button');
      var isCompact = text.length > 0 && text.length < 900;
      var isReviewPanel = isCompact && hasButtons && (
        (/^Preview hero\b/i.test(text) && /Alert day/i.test(text)) ||
        (/^Layout\b/i.test(text) && /Grid/i.test(text) && /Friday first/i.test(text)) ||
        (/^Concept\b/i.test(text) && (/Quote first/i.test(text) || /Three doors/i.test(text) || /The Ticket/i.test(text))) ||
        (/^View\b/i.test(text) && /The plan/i.test(text) && /Neighborhood page/i.test(text))
      );
      var isSeoMetadata = isCompact && /^URL\b/i.test(text) && /TITLE TAG/i.test(text) && /TARGET QUERY/i.test(text) && /SCHEMA/i.test(text);

      if (isReviewPanel || isSeoMetadata) node.hidden = true;
    });
  }

  function fieldByPlaceholder(scope, pattern) {
    return Array.from(scope.querySelectorAll('input, textarea')).find(function (field) {
      return pattern.test(field.getAttribute('placeholder') || '');
    });
  }

  function submitProtectedContact(nativeForm, kind, scope) {
    if (scope.hasAttribute('data-bc-contact-sending')) return;
    scope.setAttribute('data-bc-contact-sending', 'true');
    var done = false;
    var postStarted = false;
    var attempts = 0;
    var buttons = Array.from(scope.querySelectorAll('button')).filter(function (button) {
      return /Send private-room inquiry|Check this date|Send my request|we.ll call you today|Request a board|Send catering request|Request a callback|Send it to Tom/i.test(button.textContent || '');
    });
    buttons.forEach(function (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    var oldError = scope.querySelector('[data-bc-contact-send-error]');
    if (oldError) oldError.remove();
    function failed() {
      if (done) return;
      done = true;
      nativeForm.remove();
      scope.removeAttribute('data-bc-contact-sending');
      buttons.forEach(function (button) { button.disabled = false; button.removeAttribute('aria-busy'); });
      var message = document.createElement('p');
      message.setAttribute('role', 'alert');
      message.setAttribute('data-bc-contact-send-error', '');
      message.setAttribute('data-bc-lead-error', '');
      message.textContent = 'Your request has not been sent yet. Please refresh and try again, or call (858) 265-6702.';
      scope.appendChild(message);
    }
    function post() {
      if (done || postStarted) return;
      postStarted = true;
      try {
        if (window.BuonCiboLeadMeasurement && typeof window.BuonCiboLeadMeasurement.begin === 'function') window.BuonCiboLeadMeasurement.begin(kind, '#contact_form');
      } catch (_) {} 
      try { nativeForm.requestSubmit(); window.setTimeout(failed, 300000); }
      catch (_) { failed(); }
    }
    function protect() {
      if (done) return;
      var captcha = window.Shopify && window.Shopify.captcha;
      if (captcha && typeof captcha.protect === 'function') {
        try { captcha.protect(nativeForm, post); } catch (_) { failed(); }
      } else if (attempts++ < 40) window.setTimeout(protect, 250);
      else failed();
    }
    nativeForm.setAttribute('data-shopify-captcha', 'true');
    document.body.appendChild(nativeForm);
    window.setTimeout(function () { if (!postStarted) failed(); }, 90000);
    protect();
  }

  function submitContact(kind, scope) {
    var name = scope.querySelector('input[autocomplete="name"]') || fieldByPlaceholder(scope, /name/i);
    var email = scope.querySelector('input[type="email"]') || fieldByPlaceholder(scope, /email|@/i);
    var phone = scope.querySelector('input[type="tel"]') || fieldByPlaceholder(scope, /phone/i);
    var date = scope.querySelector('input[type="date"]');
    var notes = scope.querySelector('textarea');
    var ranges = Array.from(scope.querySelectorAll('input[type="range"]'));
    var details = ['Source: ' + kind];
    var occasion = scope.querySelector('select[data-bc-catering-occasion]') || scope.querySelector('[data-bc-catering-occasion].is-selected');
    var guestCount = scope.querySelector('[data-bc-catering-guests]');

    if (kind === 'private-room-request') {
      var chosenOption = scope.querySelector('[data-bc-room-option][aria-pressed="true"]');
      var choiceError = scope.querySelector('[data-bc-room-choice-error]');
      if (!chosenOption) {
        if (choiceError) choiceError.style.display = 'block';
        var firstOption = scope.querySelector('[data-bc-room-option]');
        if (firstOption) firstOption.focus();
        return;
      }
      if (choiceError) choiceError.style.display = 'none';
      var contactError = scope.querySelector('[data-bc-room-form-error]');
      var message = '';
      var badField = null;
      if (!name || !name.value.trim()) { message = 'Please enter your name.'; badField = name; }
      else if (!email || !email.value.trim()) { message = 'Please enter your email address.'; badField = email; }
      else if (!email.checkValidity()) { message = 'Please enter a valid email address.'; badField = email; }
      else if (!phone || !phone.value.trim()) { message = 'Please enter your phone number.'; badField = phone; }
      else if (phone.value.replace(/\D/g, '').length < 10) { message = 'Please enter a phone number with at least 10 digits.'; badField = phone; }
      if (message) {
        if (contactError) { contactError.textContent = message; contactError.style.display = 'block'; }
        if (badField) badField.focus();
        return;
      }
      if (contactError) contactError.style.display = 'none';
      details.push('Private-room option: ' + chosenOption.getAttribute('data-bc-room-option'));
    }

    var invalid = Array.from(scope.querySelectorAll('input, textarea, select')).find(function (field) {
      return field.willValidate && !field.checkValidity();
    });
    if (invalid) {
      invalid.reportValidity();
      invalid.focus();
      return;
    }

    if (date && !date.disabled && date.value) details.push('Requested date: ' + date.value);
    if (kind === 'catering-request') {
      var timing = window.BuonCiboCateringInquiry && window.BuonCiboCateringInquiry.readTiming();
      if (timing && timing.mode === 'estimate') details.push('Estimated timing: ' + timing.timeframe);
      details.push('Follow-up requested: Phone callback');
      var planner = window.BuonCiboCateringPlanner;
      var planCheck = planner && planner.validatePlan ? planner.validatePlan() : { valid: true };
      if (!planCheck.valid) {
        var planError = scope.querySelector('[data-bc-catering-plan-error]');
        if (!planError) { planError = document.createElement('p'); planError.setAttribute('data-bc-catering-plan-error', ''); planError.setAttribute('role', 'alert'); scope.querySelector('[data-bc-catering-submit]').before(planError); }
        planError.textContent = planCheck.message;
        return;
      }
      var oldError = scope.querySelector('[data-bc-catering-plan-error]');
      if (oldError) oldError.remove();
      var selection = planner && planner.summaryText();
      if (selection) details.push('\nCATERING MENU REQUEST\n' + selection);
      else details.push('Menu preference: Please help me plan');
    }
    ranges.forEach(function (range, index) {
      if (range.hasAttribute('data-bc-catering-guests')) details.push('Approximate guest count: ' + range.value + (range.value === range.max ? '+' : ''));
      else details.push('Selection ' + (index + 1) + ': ' + range.value);
    });
    if (occasion) details.push('Occasion: ' + (occasion.tagName === 'SELECT' ? occasion.value : occasion.getAttribute('data-bc-catering-occasion')));
    if (guestCount && ranges.indexOf(guestCount) === -1) details.push('Approximate guest count: ' + guestCount.value);
    if (notes && notes.value) details.push('Notes: ' + notes.value);

    // "Join our email & text list": always the email list, texts too when a real number is given.
    var optList = scope.querySelector('[data-bc-optin-list]');
    var phoneDigits = phone && phone.value ? phone.value.replace(/\D/g, '') : '';
    var wantsList = !!(optList && optList.checked && email && email.value);
    var wantsTexts = wantsList && phoneDigits.length >= 10;
    if (optList) details.push('Email & text list: ' + (wantsList ? (wantsTexts ? 'yes, email and texts' : 'yes, email') : 'no'));

    var nativeForm = document.createElement('form');
    nativeForm.method = 'post';
    nativeForm.action = '/contact#contact_form';
    nativeForm.hidden = true;

    var payload = {
      form_type: 'contact',
      utf8: '✓',
      'contact[tags]': 'website,' + kind,
      'contact[name]': name ? name.value : '',
      'contact[email]': email ? email.value : '',
      'contact[phone]': phone ? phone.value : '',
      'contact[body]': details.join('\n'),
    };

    Object.keys(payload).forEach(function (key) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = payload[key];
      nativeForm.appendChild(input);
    });

    var sent = false;
    var send = function () {
      if (sent) return;
      sent = true;
      submitProtectedContact(nativeForm, kind, scope);
    };
    if (!wantsList) {
      send();
      return;
    }
    // The contact form only emails the shop, so a list signup is a customer record,
    // created first. A slow or failed signup never holds the note back.
    var signup = new URLSearchParams();
    signup.append('form_type', 'customer');
    signup.append('utf8', '✓');
    signup.append('contact[email]', email.value);
    signup.append('contact[tags]', 'newsletter,source-page-contact' + (wantsTexts ? ',sms-optin' : ''));
    if (wantsTexts) {
      signup.append('contact[phone]', (phoneDigits.length === 10 ? '+1' : '+') + phoneDigits);
    }
    fetch('/contact', { method: 'POST', body: signup, credentials: 'same-origin', keepalive: true }).then(send, send);
    window.setTimeout(send, 2500);
  }

  function submitNewsletter(scope) {
    var email = scope.querySelector('input[type="email"]');
    if (!email || !email.value || !email.checkValidity()) {
      if (email) {
        email.reportValidity();
        email.focus();
      }
      return;
    }

    var nativeForm = document.createElement('form');
    nativeForm.method = 'post';
    nativeForm.action = '/contact#contact_form';
    nativeForm.hidden = true;

    var payload = {
      form_type: 'customer',
      utf8: '✓',
      'contact[tags]': 'newsletter',
      'contact[email]': email.value,
    };

    Object.keys(payload).forEach(function (key) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = payload[key];
      nativeForm.appendChild(input);
    });

    document.body.appendChild(nativeForm);
    nativeForm.submit();
  }

  function alignHomePreorder() {
    if (config.pageKey !== 'home') return;
    var replacements = {
      '$58 for two': '$35 for two',
      '$48 for two': '$35 for two',
      '$58': '$35',
      '$48': '$35',
      'Forty boxes, posted Wednesday morning. Regulars claim them before lunch, so this is the day to decide.': 'The current Friday dinner is released as a limited preorder. Reserve by 8:00 PM the night before.',
      'One menu, cooked once. Rigatoni al sugo, Sicilian meatballs and sausage, Caesar, garlic bread, and two cannoli. When the forty boxes are gone, that is the week.': 'This week: chicken artichoke piccata with mashed potatoes for two. Reserve by 8:00 PM Thursday; pickup Friday from 4:00–7:00 PM.',
      'Sunday lasagna orders close at four. After that the trays are counted and the sauce goes on for the morning.': 'This week: a quarter tray of meat lasagna with garlic bread for two. Reserve by 8:00 PM Saturday.',
      'House lasagna for two, sauce simmering since Saturday, garlic bread alongside. Pick it up between eleven and four, or eat it at a yellow table.': 'A quarter tray of meat lasagna with garlic bread for two. Choose the available pickup time in the current checkout.'
    };
    Array.from(mount.querySelectorAll('span, p, div')).forEach(function (node) {
      if (node.children.length) return;
      var value = (node.textContent || '').trim();
      if (Object.prototype.hasOwnProperty.call(replacements, value)) node.textContent = replacements[value];
    });
  }

  function addVariant(variantId, quantity, fallbackUrl) {
    if (!variantId) {
      window.location.assign(fallbackUrl || '/pages/contact');
      return Promise.resolve(false);
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json().catch(function () { return null; });
      })
      .then(function (result) {
        var navigated = false;
        var redirectTimer;
        function goToCart() {
          if (navigated) return;
          navigated = true;
          window.clearTimeout(redirectTimer);
          window.location.assign('/cart');
        }
        try {
          if (result && window.BuonCiboAnalytics && typeof window.BuonCiboAnalytics.trackAddToCart === 'function') {
            redirectTimer = window.setTimeout(goToCart, 800);
            if (window.BuonCiboAnalytics.trackAddToCart(result.items || result, [{ id: Number(variantId), quantity: quantity || 1 }], goToCart) === true) return true;
          }
        } catch (_) { /* Measurement must never interrupt a successful cart addition. */ }
        goToCart();
        return true;
      })
      .catch(function () {
        window.location.assign(fallbackUrl || '/pages/contact');
        return false;
      });
  }

  mount.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('button, a');
      if (!button) return;
      var label = (button.textContent || '').replace(/\s+/g, ' ').trim();

      if (button.hasAttribute('data-bc-commerce-action')) return;

      if (button.hasAttribute('data-bc-catering-occasion')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var inquiry = button.closest('[data-bc-catering-inquiry]');
        Array.from(inquiry.querySelectorAll('[data-bc-catering-occasion]')).forEach(function (option) {
          var selected = option === button;
          option.classList.toggle('is-selected', selected);
          option.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        return;
      }

      if (/Send it to Tom/i.test(label)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        submitContact('general-contact', button.closest('section') || mount);
        return;
      }
      if (button.hasAttribute('data-bc-catering-submit') || /Send my request/i.test(label) || /we.ll call you today/i.test(label) || /Request a board/i.test(label)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        submitContact('catering-request', button.closest('[data-bc-catering-inquiry]') || button.closest('section') || mount);
        return;
      }
      if (/Send private-room inquiry|Check this date/i.test(label)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        submitContact('private-room-request', button.closest('section') || mount);
        return;
      }

      var form = button.closest('form');
      if (/^Join(?: the)?(?: list| waitlist)?$/i.test(label)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        submitNewsletter(form || button.closest('section') || mount);
        return;
      }

      if (/Reserve for Friday/i.test(label)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addVariant(config.products && config.products.primaryVariantId, 1, operationalUrls.preorderFriday);
        return;
      }

    },
    true
  );

  mount.addEventListener('input', function (event) {
    if (!event.target.hasAttribute('data-bc-catering-guests')) return;
    var output = event.target.closest('[data-bc-catering-inquiry]').querySelector('[data-bc-catering-guests-output]');
    if (output) output.textContent = event.target.value === event.target.max ? event.target.value + '+ guests' : event.target.value + ' guests';
  });

  mount.addEventListener('keydown', function (event) {
    var range = event.target.closest && event.target.closest('input[type="range"][data-bc-catering-guests]');
    if (!range) return;
    var current = Number(range.value);
    var minimum = Number(range.min);
    var maximum = Number(range.max);
    var step = Number(range.step) || 1;
    var next = current;
    if (event.key === 'ArrowRight' || event.key === 'ArrowUp') next = current + step;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') next = current - step;
    else if (event.key === 'PageUp') next = current + step * 10;
    else if (event.key === 'PageDown') next = current - step * 10;
    else if (event.key === 'Home') next = minimum;
    else if (event.key === 'End') next = maximum;
    else return;

    event.preventDefault();
    event.stopImmediatePropagation();
    range.value = String(Math.max(minimum, Math.min(maximum, next)));
    var inquiry = range.closest('[data-bc-catering-inquiry]');
    var output = inquiry && inquiry.querySelector('[data-bc-catering-guests-output]');
    if (output) output.textContent = range.value === range.max ? range.value + '+ guests' : range.value + ' guests';
  }, true);

  function connectDingemanHome() {
    if (config.pageKey !== 'home') return;
    var featuredItems = mount.querySelector('section.bc-quick-wrap');
    if (!featuredItems) return;
    var featureTemplate = shell.querySelector('[data-bc-dingeman-home-feature]');
    if (featureTemplate && !mount.querySelector('[data-bc-dingeman-home-feature-mounted]')) {
      featuredItems.parentNode.insertBefore(document.importNode(featureTemplate.content, true), featuredItems.nextSibling);
    }
  }

  function improveRenderedConcept() {
    connectReviewSlots();
    connectSharedFooter();
    connectNewsletter();
    connectFooterRoutes();
    connectHeaderRoutes();
    connectDingemanHome();
    announceOnlineOrderingPause();
    connectOperationalRoutes();
    connectCateringMenu();
    connectFullCateringMenu();
    alignCateringClaims();
    buildCateringInquiry();
    // Boxed lunches and packages are integrated into the unified catering menu.
    alignHomePreorder();
    repairFragmentRoutes();
    improveFieldAccessibility();
    optimizeImages();
    hideReviewChrome();
    improveConceptLandmarks();
    improveHeadingStructure();
    improveChoiceButtonSemantics();

    var cartLink = Array.from(mount.querySelectorAll('a')).find(function (link) {
      return /^Cart\s*·/i.test((link.textContent || '').trim());
    });
    if (cartLink) cartLink.href = '/cart';

  }

  var observer = new MutationObserver(improveRenderedConcept);
  observer.observe(mount, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'src', 'data-bc-review-topic'] });
  improveRenderedConcept();
})();
